import React from 'react';
import { CloseIcon } from 'assets/icons';
import { Button } from 'components';
import { Globals } from 'utils';
import { UsersService } from 'services';

interface ModalApproveDoctorProps {
  user?: any
  onClose: (reload?: boolean) => void
}

export const ModalApproveDoctor = ({ user, onClose }: ModalApproveDoctorProps) => {

  const onSubmit = async () => {
    try {
      await UsersService.approveDoctor({ user_id: user.id });
      onClose(true);
      Globals.showSuccess('Médico aprobado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea aprobar este médico?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalRejectDoctorProps {
  user?: any
  onClose: (reload?: boolean) => void
}

export const ModalRejectDoctor = ({ user, onClose }: ModalRejectDoctorProps) => {

  const onSubmit = async () => {
    try {
      await UsersService.rejectDoctor({ user_id: user.id });
      onClose(true);
      Globals.showSuccess('Médico rechazado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea rechazar este médico?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalEnableDoctorProps {
  user?: any
  onClose: (reload?: boolean) => void
}

export const ModalEnableDoctor = ({ user, onClose }: ModalEnableDoctorProps) => {

  const onSubmit = async () => {
    try {
      await UsersService.enableDoctor({ user_id: user.id });
      onClose(true);
      Globals.showSuccess('Médico habilitado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea habilitar este médico?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalDisableDoctorProps {
  user?: any
  onClose: (reload?: boolean) => void
}

export const ModalDisableDoctor = ({ user, onClose }: ModalDisableDoctorProps) => {

  const onSubmit = async () => {
    try {
      await UsersService.disableDoctor({ user_id: user.id });
      onClose(true);
      Globals.showSuccess('Médico inhabilitado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea bloquear este médico?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalDeletePatientProps {
  user?: any
  onClose: (reload?: boolean) => void
}

export const ModalDeletePatient = ({ user, onClose }: ModalDeletePatientProps) => {

  const onSubmit = async () => {
    try {
      await UsersService.deletePatient({ user_id: user.id });
      onClose(true);
      Globals.showSuccess('Paciente eliminado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea eliminar este paciente?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}

interface ModalDeleteCompanyProps {
  user?: any
  onClose: (reload?: boolean) => void
}

export const ModalDeleteCompany = ({ user, onClose }: ModalDeleteCompanyProps) => {

  const onSubmit = async () => {
    try {
      await UsersService.deletePatient({ user_id: user.id });
      onClose(true);
      Globals.showSuccess('Empresa eliminada');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea eliminar esta empresa?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}